module.exports = __webpack_public_path__ + "static/media/34.505047c9.webp";